var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{class:_vm.cssClass,on:{"click":function($event){return _vm.sortRows(_vm.column.sortable ? _vm.column.id : false)}}},[_vm._v(" "+_vm._s(_vm.column.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }